export default __webpack_public_path__ + "static/media/greyPlus.488ce239.svg";